import React, { createContext, useContext, ReactNode } from 'react';
import { User } from 'firebase/auth';
import { BaseUser } from '../types/user';
import useAuth from '../hooks/useAuth';
import LoadingSpinner from '../components/LoadingSpinner';

interface AuthContextType {
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
  user: User | null;
  userData: BaseUser | null;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const auth = useAuth();

  if (auth.isLoading) {
    return <LoadingSpinner fullScreen message="Loading..." />;
  }

  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
};

export default AuthContext;
